import { useEffect } from "react";

export default function HugRedirect() {
  useEffect(() => {
    window.location.replace("https://hug-artist-hub-1.emergent.host");
  }, []);

  // Show loading message while redirecting
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#030303', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: '#888'
    }}>
      <p>Redirecting to HUG...</p>
    </div>
  );
}
